const ServerErrorToText = {
  internetConnectionError:
    'Sorry, please check your internet connection and try again',

  unknownError: 'Sorry, something went wrong',
  invalidParametersError: 'Sorry, please provide valid parameters',

  notLoggedInError: 'Please log in to access this page',
  invalidTokenError:
    'Sorry, you have been logged out automatically, please log in again',
  unauthorizedError: 'Sorry, you are not authorized to access this page',

  invalidConfigStateError: 'Sorry, this function is unavailable currently',
  invalidAcademicSessionError:
    'Sorry, this item belongs to an invalid academic session',
  invalidNextStateError:
    'Sorry, transition to the next state is not allowed currently',
  noAcademicSessionError:
    'Sorry, there is currently no active academic session',
  outdatedConfigError: 'Sorry, please try again',
  invalidAcademicYearError:
    'Sorry, new academic year must be bigger than previous academic year',

  titleSubmissionDeadlineError:
    'Sorry, project title submission is currently not available',
  bidDeadlineError: 'Sorry, project title bidding is currently not available',
  bidReviewDeadlineError:
    'Sorry, project title bid review is currently not available',
  evaluationDeadlineError:
    'Sorry, project grade evaluation is currently not available',

  duplicateEmailError: 'This email address is already registered',
  invalidEmailOrPasswordError:
    'Sorry, the email address and/or password are incorrect',
  errorInvalidPassword:
    'Please enter a valid password (8 - 30 characters with at least one alphabet, one number and one special character)',
  wrongPasswordError: 'Please enter the correct password',
  userNotFoundError: 'Sorry, the user cannot be found',
  userAlreadyActivatedError:
    'Your user account has already been activated, please log in using your new password',
  resetPasswordError:
    'Sorry, your password reset link is invalid, please get a new link and retry',

  duplicateAcademicSessionError: 'This academic session is already registered',
  duplicateCategoryCodeOrCategoryNameError:
    'This category code or category name is already registered',

  projectNotFoundError: 'Sorry, the project cannot be found',
  bidNotFoundError: 'Sorry, the bid cannot be found',

  duplicateLecturerIDError: 'Sorry, the Lecturer ID is already registered',
  duplicateMatricError: 'Sorry, the Matric No. is already registered',
  invalidLecturerExcelFileError:
    "Sorry, your lecturer excel file is invalid, please follow the syntax ('Lecturer No.', 'Name', 'Email', 'Academic Session')",
  invalidLecturerExcelFileContentError:
    'Sorry, your lecturer excel file contains some error values. Kindly check your excel file before upload again',
  invalidStudentExcelFileError:
    "Sorry, your student excel file is invalid, please follow the syntax ('Matric No.', 'Name', 'Email', 'Academic Session')",
  invalidStudentExcelFileContentError:
    'Sorry, your student excel file contains some error values. Kindly check your excel file before upload again',
  firstAcademicSessionError: 'Sorry, first academic session must set to true',
  noCurrError: 'Sorry, current academic session cannot set to false',

  methodNotAllowedError: 'Sorry, actions are not allowed',

  emailError:
    'Sorry, email cannot be sent, please check your email and try again.',

  activationError: 'Sorry, this user has been activated.',

  messageChangeTempPasswordError:
    'Please change your temporary password using the link sent to your email to activate your account',
  messageAlreadyLoggedOutError: 'You have already been logged out',

  exceedBidQuotaError: `Sorry, you have exceed maximum number of bids`,
  exceedTitleQuotaError: `Sorry, you have exceed maximum number of title submission!s`,
  duplicateProjectBiddingError:
    'Sorry, same project is not allowed to bid more than one time.',
};

export default ServerErrorToText;
